"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDUCATION = exports.HOUSEHOLD_INVESTABLE_ASSETS = exports.MARTIAL_STATUS = exports.RACE_ETHNICITY = exports.HOUSEHOLD_GROSS_INCOME = exports.NUMBER_PPL_IN_HOUSEHOLD = exports.SEXUAL_ORIENTATION = exports.HOME_TYPE = exports.PRIMARY_VEHICLES = exports.NON_ALCOHOLIC_BEVERAGES = exports.NUMBER_OF_CHILDREN = exports.ENGINE_TYPE = exports.PETS_IN_HOUSEHOLD = exports.EMPLOYMENT_STATUS = exports.HOUSEHOLD_APPLICANCE_OWNED = exports.VEHICLES_IN_HOUSEHOLD = exports.HOUSEHOLD_CHILDREN = exports.FINANCIAL_PRODUCT = exports.LANGUAGE_FLUENCY = exports.FINANCIAL_SERVICES = exports.FINANCIAL_INSURANCE_PRODUCT = exports.PERSONAL_CARE_PRODUCTS = exports.HHR = exports.AGE = exports.GENDER = exports.getDefaultMultipleChoiceQuestion = exports.getDefaultQuestion = void 0;
var constants_1 = require("../../constants");
var types_1 = require("../types");
var types_2 = require("../../types");
var question_1 = require("../../utils/question");
var TextService_1 = require("../../services/TextService");
/** @TODO Add age question in audience v2.0*/
var getDefaultQuestion = function (t, languages, translateKey, title, value, hasQuestionTexts, translationOptions, type, selectedOptionType) {
    if (translationOptions === void 0) { translationOptions = {}; }
    if (type === void 0) { type = types_2.QTYPES.SINGLE_CHOICE; }
    if (selectedOptionType === void 0) { selectedOptionType = types_2.OPTION_TYPES.TEXT_ONLY; }
    var q = {
        id: constants_1.BUILTIN_QUESTION_ID,
        questionTexts: [],
        type: type,
        title: title,
        value: value,
        selectedOptionType: selectedOptionType
    };
    if (hasQuestionTexts) {
        var questionTexts = (0, TextService_1.generateMultimediaTextFromTranslation)(languages, t, translateKey, translationOptions);
        q = __assign(__assign({}, q), { questionTexts: questionTexts });
    }
    return q;
};
exports.getDefaultQuestion = getDefaultQuestion;
var getDefaultMultipleChoiceQuestion = function (t, languages, translateKey, title, value, max, hasQuestionTexts, hasContinue, hasNotApplicable, selectedOptionType) {
    if (hasContinue === void 0) { hasContinue = true; }
    if (hasNotApplicable === void 0) { hasNotApplicable = true; }
    if (selectedOptionType === void 0) { selectedOptionType = types_2.OPTION_TYPES.TEXT_ONLY; }
    var question = __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, title, value, hasQuestionTexts, {}, types_2.QTYPES.MULTIPLE_CHOICE, selectedOptionType)), { min: 1, max: max });
    if (hasContinue) {
        question = __assign(__assign({}, question), { showContinueButton: true, continueTexts: (0, TextService_1.createTextMultimediaText)(t, languages, 'BUTTON.CONTINUE', 'Continue') });
    }
    if (hasNotApplicable) {
        question = __assign(__assign({}, question), { showNotApplicableOption: true, notApplicableTexts: (0, TextService_1.createTextMultimediaText)(t, languages, '', 'None of the above') });
    }
    return question;
};
exports.getDefaultMultipleChoiceQuestion = getDefaultMultipleChoiceQuestion;
var GENDER = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.GENDER;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Male',
            value: '1',
            mediaURL: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/options/gender/male.png"),
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female',
            value: '2',
            mediaURL: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/options/gender/female.png"),
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Other',
            value: constants_1.BUILT_IN_OPTION_VALUE,
            mediaURL: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/options/gender/nonbinary.png"),
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Gender', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts), {}, types_2.QTYPES.SINGLE_CHOICE, types_2.OPTION_TYPES.IMAGE_AND_TEXT)), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.GENDER = GENDER;
var AGE = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.AGE;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Age', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts), {}, types_2.QTYPES.NUMERIC)), { min: 16, max: 99, openEndedSettings: {
            showMax: true,
            showMin: true
        }, showNotApplicableOption: false, showContinueButton: true, audienceSettings: {
            min: 16,
            max: 99,
            openEndedSettings: {
                showMax: true,
                showMin: true
            }
        } });
};
exports.AGE = AGE;
var HHR = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.HHR;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Primary decision maker',
            value: '1',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Joint decision maker',
            value: '2',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Not a decision maker',
            value: '3',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Other',
            value: '4',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'None of the above',
            value: '99',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'HouseHold Role', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.HHR = HHR;
var PERSONAL_CARE_PRODUCTS = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.PERSONAL_CARE_PRODUCTS;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Anti-aging',
            value: '1',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Body lotion',
            value: '2',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Conditioner',
            value: '3',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Denture adhesive',
            value: '20',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Deodorant',
            value: '4',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Electric shaver / Electric Razor',
            value: '5',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Eye Shadow / Makeup',
            value: '6',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Facial Cleanser',
            value: '7',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Facial Serum or Moisturizer',
            value: '8',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Foundation makeup',
            value: '9',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Hand Cream',
            value: '10',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Lipstick',
            value: '11',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Makeup Removing Cream / Lotion',
            value: '12',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Manual razor',
            value: '13',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Perfume / Cologne',
            value: '14',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Nail polish',
            value: '15',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Shampoo',
            value: '16',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Shaving Gel / Cream',
            value: '17',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Skin Whitening',
            value: '19',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Toothpaste',
            value: '18',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Personal Care Products', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.PERSONAL_CARE_PRODUCTS = PERSONAL_CARE_PRODUCTS;
var FINANCIAL_INSURANCE_PRODUCT = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.FINANCIAL_INSURANCE_PRODUCT;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Auto Insurance',
            value: '1',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Health Insurance',
            value: '2',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Home Insurance',
            value: '3',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Life Insurance',
            value: '4',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Renters Insurance',
            value: '5',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Other Type of Insurance',
            value: '998',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Financial Insurance Products', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.FINANCIAL_INSURANCE_PRODUCT = FINANCIAL_INSURANCE_PRODUCT;
var FINANCIAL_SERVICES = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.FINANCIAL_SERVICES;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Auto Loan',
            value: '1',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Checking Account',
            value: '2',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Money Market Account',
            value: '3',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Mortgage',
            value: '4',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Savings Account',
            value: '5',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Other account not listed',
            value: '998',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Financial Services', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.FINANCIAL_SERVICES = FINANCIAL_SERVICES;
var LANGUAGE_FLUENCY = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.LANGUAGE_FLUENCY;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Arabic',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Chinese - Cantones',
            value: '2',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Chinese - Mandarin',
            value: '10',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Chinese - Other',
            value: '1002',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Dutch',
            value: '1005',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'English',
            value: '999',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'French',
            value: '3',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'German',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Hindi',
            value: '6',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Italian',
            value: '7',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Japanese',
            value: '8',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Korean',
            value: '9',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Portuguese',
            value: '11',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Russian',
            value: '12',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Serbian',
            value: '13',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Spanish',
            value: '14',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Turkish',
            value: '1043',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Welsh',
            value: '1047',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Vietnamese',
            value: '15',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Other',
            value: '997',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Languages fluently spoken at home', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.LANGUAGE_FLUENCY = LANGUAGE_FLUENCY;
var FINANCIAL_PRODUCT = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.FINANCIAL_PRODUCTS;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Auto Loan',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Term Deposit/Certificate of Deposit',
            value: '4',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Checking Account',
            value: '5',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Debit Card',
            value: '8',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Credit Card',
            value: '9',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Savings Account',
            value: '14',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Home Equity Loan / Line of Credit',
            value: '15',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Bonds',
            value: '16',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Money Market Account',
            value: '26',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Mortgage',
            value: '32',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Investment Fund/Mutual Fund',
            value: '33',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA
            ]
        },
        {
            label: 'Personal Loan (unsecured)',
            value: '35',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Prepaid Card',
            value: '38',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Stocks and Shares',
            value: '43',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Financial Products & Services', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.FINANCIAL_PRODUCT = FINANCIAL_PRODUCT;
var HOUSEHOLD_CHILDREN = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.HHC;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Female Children - < 1 year old',
            value: '37',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 1 year old',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 2 years old',
            value: '2',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 3 years old',
            value: '3',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 4 years old',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 5 years old',
            value: '5',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 6 years old',
            value: '6',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 7 years old',
            value: '7',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 8 years old',
            value: '8',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 9 years old',
            value: '9',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 10 years old',
            value: '10',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 11 years old',
            value: '11',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 12 years old',
            value: '12',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 13 years old',
            value: '13',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 14 years old',
            value: '14',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 15 years old',
            value: '15',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 16 years old',
            value: '16',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 17 years old',
            value: '17',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Female Children - 18 years old',
            value: '18',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - < 1 year old',
            value: '38',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 1 year old',
            value: '19',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 2 years old',
            value: '20',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 3 years old',
            value: '21',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 4 years old',
            value: '22',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 5 years old',
            value: '23',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 6 years old',
            value: '24',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 7 years old',
            value: '25',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 8 years old',
            value: '26',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 9 years old',
            value: '27',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 10 years old',
            value: '28',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 11 years old',
            value: '29',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 12 years old',
            value: '30',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 13 years old',
            value: '31',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 14 years old',
            value: '32',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 15 years old',
            value: '33',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 16 years old',
            value: '34',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 17 years old',
            value: '35',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Male Children - 18 years old',
            value: '36',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Household Children 1 - 18 years', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts), true, false)), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.HOUSEHOLD_CHILDREN = HOUSEHOLD_CHILDREN;
var VEHICLES_IN_HOUSEHOLD = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.VEHICLES_IN_HOUSEHOLD;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: '1',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '2',
            value: '2',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '3+',
            value: '3',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'None',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Vehicles in Household', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.VEHICLES_IN_HOUSEHOLD = VEHICLES_IN_HOUSEHOLD;
var HOUSEHOLD_APPLICANCE_OWNED = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.HOUSEHOLD_APPLICANCE_OWNED;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Air-conditioner',
            value: '1',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Cooker hood',
            value: '2',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Dishwasher',
            value: '3',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Dryer',
            value: '4',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'DVD/BD player, recorder',
            value: '5',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Electric iron',
            value: '6',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Hob',
            value: '7',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Microwave oven',
            value: '8',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Mobile phone (including Smartphone)',
            value: '9',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Oven',
            value: '10',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Refrigerator',
            value: '11',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Soda Machine/ Soda Maker',
            value: '12',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'TV',
            value: '13',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Vacuum cleaner',
            value: '14',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Washing machine',
            value: '15',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Washing machine (incl. washer-dryer)',
            value: '16',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Household Appliances Owned', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.HOUSEHOLD_APPLICANCE_OWNED = HOUSEHOLD_APPLICANCE_OWNED;
var EMPLOYMENT_STATUS = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.EMPLOYMENT_STATUS;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Full-time',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Part-time',
            value: '2',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        // {
        //     label: 'Contract, Freelance or Temporary Employee',
        //     value: '3',
        //     supportedCountries: ENG_COUNTRIES
        // },
        {
            label: 'Self-employed (Contract, Freelance, Temporary Employee, Etc.)',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        // {
        //     label: 'Semi-retired',
        //     value: '5',
        //     supportedCountries: ENG_COUNTRIES
        // },
        {
            label: 'Retired',
            value: '6',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Unemployed and not looking for work',
            value: '7',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        // {
        //     label: 'Stay-at-Home Parent',
        //     value: '8',
        //     supportedCountries: [
        //         SUPPORTED_COUNTRY_ISO.CA,
        //         SUPPORTED_COUNTRY_ISO.US,
        //         SUPPORTED_COUNTRY_ISO.GB
        //     ]
        // },
        {
            label: 'Student',
            value: '9',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        // {
        //     label: 'Part-time Student (working MORE than 30 hours per week)',
        //     value: '10',
        //     supportedCountries: ENG_COUNTRIES
        // },
        // {
        //     label: 'Part-time Student (working LESS than 30 hours per week)',
        //     value: '11',
        //     supportedCountries: ENG_COUNTRIES
        // },
        {
            label: 'Unemployed and looking for work',
            value: '12',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        // {
        //     label: 'Disabled',
        //     value: '13',
        //     supportedCountries: ENG_COUNTRIES
        // },
        {
            label: 'None of the above',
            value: '14',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Employment Status', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.EMPLOYMENT_STATUS = EMPLOYMENT_STATUS;
var PETS_IN_HOUSEHOLD = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.PETS_IN_HOUSEHOLD;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Birds',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Cats',
            value: '2',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Dogs',
            value: '3',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Fish',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Horses',
            value: '5',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Livestock (Goats, Pigs, Cattle, etc.)',
            value: '7',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Reptiles / Amphibians',
            value: '8',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Small Animals (Hamsters, Gerbils, Mice, Rats, etc.)',
            value: '9',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Pets or Animals in the Household', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.PETS_IN_HOUSEHOLD = PETS_IN_HOUSEHOLD;
var ENGINE_TYPE = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.ENGINE_TYPE;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            value: '2',
            label: 'Diesel engine',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            value: '7',
            label: 'Electric',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            value: '1',
            label: 'Petrol engine',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            value: '3',
            label: 'Hybrid engine',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            value: '4',
            label: 'Natural Gas engine',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            value: '5',
            label: 'Other',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            value: '6',
            label: "Don't know",
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Type of Engine', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.ENGINE_TYPE = ENGINE_TYPE;
var NUMBER_OF_CHILDREN = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.NUM_CHILDREN;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'None',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '1',
            value: '2',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '2',
            value: '3',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '3',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '4',
            value: '5',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '5 or more',
            value: '6',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Prefer not to state',
            value: '7',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Number of Children', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.NUMBER_OF_CHILDREN = NUMBER_OF_CHILDREN;
var NON_ALCOHOLIC_BEVERAGES = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.NON_ALCOHOLIC_BEVERAGES;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Carbonated Soft Drinks',
            value: '3',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Coffee',
            value: '5',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Weight Loss Drinks',
            value: '6',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Tea',
            value: '10',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Juices',
            value: '11',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Meal replacement',
            value: '15',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Energy/Sport Drinks',
            value: '17',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Bottled Water',
            value: '19',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Non-Alcoholic Beverages', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.NON_ALCOHOLIC_BEVERAGES = NON_ALCOHOLIC_BEVERAGES;
var PRIMARY_VEHICLES = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.PRIMARY_VEHICLES;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Hatchback',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'MPV',
            value: '5',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Pickup',
            value: '6',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Roadster',
            value: '7',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Wagon',
            value: '12',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Hybrid Car',
            value: '18',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Hybrid SUV',
            value: '19',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Hybrid Truck',
            value: '20',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Electric Car',
            value: '21',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Crossover / Compact SUV',
            value: '22',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Midsize SUV',
            value: '23',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Fullsize SUV',
            value: '24',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Luxury SUV',
            value: '25',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Compact Sedan',
            value: '26',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Midsize Sedan',
            value: '27',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Fullsize Sedan',
            value: '28',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Luxury Sedan',
            value: '29',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Compact Pickup Truck',
            value: '30',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Midsize Pickup Truck',
            value: '31',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Fullsize Pickup Truck',
            value: '32',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Heavy-Duty Pickup Truck',
            value: '33',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Minivan / Van',
            value: '34',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Coupe',
            value: '35',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Convertible',
            value: '36',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Sports Car',
            value: '37',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Small car',
            value: '38',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Compact car',
            value: '39',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Saloon',
            value: '40',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Estate',
            value: '41',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Coupe',
            value: '42',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Convertible',
            value: '43',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Sports car',
            value: '44',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Van / Minivan',
            value: '45',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'SUV',
            value: '46',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'All-terrain vehicl',
            value: '47',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Commercial vehicle',
            value: '48',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Camper',
            value: '49',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Other',
            value: '50',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Other',
            value: '51',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Primary Vehicle Category', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.PRIMARY_VEHICLES = PRIMARY_VEHICLES;
var HOME_TYPE = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.HOME_TYPE;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Single Family Dwelling / House',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Multiple Family Dwelling (Duplex, Triplex, etc.)',
            value: '2',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Apartment',
            value: '3',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Condominium / Townhouse / Cooperative',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Manufactured / Mobile Home',
            value: '5',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'College Dormitory',
            value: '6',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'None of these',
            value: '7',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Home - Type of Structure', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.HOME_TYPE = HOME_TYPE;
var SEXUAL_ORIENTATION = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.SEXUAL_ORIENTATION;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Asexual',
            value: '7',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Lesbian/Gay',
            value: '2',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Straight/Heterosexual',
            value: '1',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Bisexual/Pansexual',
            value: '3',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Other',
            value: '5',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Unsure',
            value: '8',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Prefer not to say',
            value: '6',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Sexual Orientation', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.SEXUAL_ORIENTATION = SEXUAL_ORIENTATION;
var NUMBER_PPL_IN_HOUSEHOLD = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.NUMBER_IN_HOUSEHOLD;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: '1',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '2',
            value: '2',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '3',
            value: '3',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '4',
            value: '4',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: '5 or more',
            value: '5',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Number in Household', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.NUMBER_PPL_IN_HOUSEHOLD = NUMBER_PPL_IN_HOUSEHOLD;
var HOUSEHOLD_GROSS_INCOME = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.HOUSEHOLD_GROSS_INCOME;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Under £10,000',
            value: '57',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£10,000 - £19,999',
            value: '58',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£20,000 - £29,999',
            value: '59',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£30,000 - £39,999',
            value: '60',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£40,000 - £49,999',
            value: '61',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£50,000 - £59,999',
            value: '62',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£60,000 - £69,999',
            value: '63',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£70,000 - £79,999',
            value: '64',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£80,000 - £89,999',
            value: '65',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£90,000 - £99,999',
            value: '66',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£100,000 - £149,999',
            value: '67',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£150,000 - £199,999',
            value: '68',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£200,000 - £499,999',
            value: '69',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£500,000 or more',
            value: '70',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Less than 15,000 AUD',
            value: '91',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '15,000 to 29,999 AUD',
            value: '92',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '30,000 to 44,999 AUD',
            value: '93',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '45,000 to 59,999 AUD',
            value: '94',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '60,000 to 74,999 AUD',
            value: '95',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '75,000 to 99,999 AUD',
            value: '96',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '100,000 to 149,999 AUD',
            value: '97',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '150,000 to 199,999 AUD',
            value: '98',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '200,000 to 499,999 AUD',
            value: '99',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '500,000 to 999,999 AUD',
            value: '100',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '1 million + AUD',
            value: '101',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Less than 15,000',
            value: '102',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '15,000 to 24,999',
            value: '103',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '25,000 to 49,999',
            value: '104',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '50,000 to 74,999',
            value: '106',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '75,000 to 99,999',
            value: '107',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '100,000 to 149,999',
            value: '108',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '150,000 to 199,999',
            value: '109',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '200,000 to 249,999',
            value: '110',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '250,000 to 499,999',
            value: '111',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '500,000 to 999,999',
            value: '112',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '1 million +',
            value: '113',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Less than $21,000',
            value: '114',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.NZ]
        },
        {
            label: '$21,000 to $40,000',
            value: '115',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.NZ]
        },
        {
            label: '$41,000 to $60,000',
            value: '116',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.NZ]
        },
        {
            label: '$61,000 to $80,000',
            value: '117',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.NZ]
        },
        {
            label: '$81,000 to $100,000',
            value: '118',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.NZ]
        },
        {
            label: 'Over $100,000',
            value: '120',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.NZ]
        },
        {
            label: 'Not earning/No income',
            value: '366',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Prefer not to answer',
            value: '426',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Gross Income - Household ANNUAL', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.HOUSEHOLD_GROSS_INCOME = HOUSEHOLD_GROSS_INCOME;
var RACE_ETHNICITY = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.RACE_ETHNICITY;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Aboriginal',
            value: '1',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'African',
            value: '2',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Asian / Asian British',
            value: '5',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Australian',
            value: '7',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Black / Black British',
            value: '8',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Black',
            value: '9',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Asian',
            value: '10',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Caucasian / White',
            value: '11',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Chinese',
            value: '13',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Mixed descent (e.g. White & Asian, White & Black)',
            value: '16',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Native American, Inuit or Aleut',
            value: '17',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Native Hawaiian / Pacific Islander',
            value: '18',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'North African and Middle Eastern',
            value: '19',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'North American',
            value: '20',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'North and West European (e.g. United Kingdom, France, Germany, Norway, Sweden)',
            value: '22',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'North East Asian (e.g. Chinese, Japanese, Korean)',
            value: '21',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Pacific Islander',
            value: '23',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'South American',
            value: '24',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'South and East European (e.g. Spain, Italy, Greece, Hungary, Romania, Ukraine)',
            value: '25',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'South East Asian (e.g. Vietnamese, Filipino, Indonesian)',
            value: '27',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Southern and Central Asian (e.g. Indian)',
            value: '26',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Torres Strait Islander/ Indigenous Australian',
            value: '28',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'White (British / Irish / Other)',
            value: '29',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Other Oceanian',
            value: '30',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Other',
            value: '49',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        },
        {
            label: 'Prefer not to answer',
            value: '50',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Race/Ethnicity', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.RACE_ETHNICITY = RACE_ETHNICITY;
var MARTIAL_STATUS = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.MARITAL_STATUS;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Single',
            value: '1',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Married',
            value: '2',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Living with Partner',
            value: '3',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Divorced',
            value: '5',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Widowed',
            value: '6',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Civil Union / Civil Partnership / Registered Domestic Partnership',
            value: '7',
            supportedCountries: types_1.ENG_COUNTRIES
        },
        {
            label: 'Prefer not to answer',
            value: '8',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Marital Status', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.MARTIAL_STATUS = MARTIAL_STATUS;
var HOUSEHOLD_INVESTABLE_ASSETS = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.HOUSEHOLD_INVESTABLE_ASSETS;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Less than £20,000,',
            value: '32',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£20,000 to £49,999,',
            value: '33',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£50,000 to £99,999,',
            value: '34',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£100,000 to £249,999',
            value: '35',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£250,000 to £499,999',
            value: '36',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£500,000 to £1 million',
            value: '37',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£1 million to £2.49 million',
            value: '38',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: '£2.5 million to £5 million,',
            value: '39',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'More than £5 million,',
            value: '40',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Less than 50,000 AUD',
            value: '41',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '50,000 to 99,999 AUD',
            value: '42',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '100,000 to 249,999 AUD',
            value: '43',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '250,000 to 499,999 AUD',
            value: '44',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '500,000 to 999,999 AUD',
            value: '45',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '1 million to 2.49 million AUD',
            value: '46',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: '2.5 million to 5 million AUD',
            value: '47',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'More than 5 million AUD',
            value: '48',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Less than $25,000',
            value: '49',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$25,000 to $49,999',
            value: '50',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$50,000 to $99,999',
            value: '51',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$100,000 to $249,999',
            value: '52',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$250,000 to $499,999',
            value: '53',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$500,000 to $999,999',
            value: '54',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$1 million to $2.49 million',
            value: '55',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$2.5 million to $4.99 million',
            value: '56',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$5 million to $9.99 million',
            value: '57',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$10 million to $24.99 million',
            value: '58',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: '$25 million +',
            value: '59',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'I do not have any investable assets at this time',
            value: '235',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Prefer not to answer',
            value: '236',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.GB
            ]
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Investable Assets - Household', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.HOUSEHOLD_INVESTABLE_ASSETS = HOUSEHOLD_INVESTABLE_ASSETS;
var EDUCATION = function (t, languages, selectedCountry, settings) {
    var value = types_1.DYNATA_QVALUE.EDUCATION;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Junior High or Middle School',
            value: '8',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'High School Diploma, Secondary School/A-Levels Graduate',
            value: '12',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Some High School, Secondary School/A-Levels',
            value: '13',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Incomplete Secondary Education  (Below GC SE / O Level)',
            value: '17',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Secondary Education Completed (GCSE / O Level / CSE or equivalent)',
            value: '19',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Secondary Education Completed (A Level or equivalent)',
            value: '21',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Some Vocational or Technical Qualifications',
            value: '23',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Vocational or Technical Qualifications Completed (e.g. HND, NVQ)',
            value: '25',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Postgraduate Education Completed  (e.g. Masters)',
            value: '26',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'University Education Completed (First Degree e.g. BA, BSc)',
            value: '29',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Doctorate, Post-doctorate or equivalent  (Higher Degree)',
            value: '30',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.GB]
        },
        {
            label: 'Incomplete Secondary (high school) Education',
            value: '31',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.US,
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Secondary (high school) Education',
            value: '32',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.US]
        },
        {
            label: 'Some College, University, Technical School or Further Education',
            value: '33',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.CA,
                types_1.SUPPORTED_COUNTRY_ISO.US
            ]
        },
        {
            label: 'Undergraduate, University Degree',
            value: '34',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Some Postgraduate',
            value: '35',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Graduate/Post Graduate Degree',
            value: '36',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.CA]
        },
        {
            label: 'Vocational or Technical Degree',
            value: '37',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.US]
        },
        {
            label: "Associate's Degree",
            value: '38',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.US]
        },
        {
            label: "Bachelor's Degree",
            value: '39',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.US]
        },
        {
            label: "Master's Degree",
            value: '40',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.US]
        },
        {
            label: 'Doctoral or Professional Degree (PhD, Ed.D, JD, DVM, DO, MD, DDS, or similar)',
            value: '41',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.US]
        },
        {
            label: 'Incomplete Secondary Education',
            value: '44',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Secondary Education Completed',
            value: '46',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Some University or Vocational Certification (Polytechnic Certificate)',
            value: '47',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.NZ]
        },
        {
            label: 'Vocational or Professional Certification Completed (Polytechnic Diploma)',
            value: '48',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.NZ]
        },
        {
            label: 'Some University or Vocational Certification',
            value: '49',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Some University or Vocational Certification (TAFE Certificate I, II,III or IV)',
            value: '55',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Vocational or Professional Certification Completed',
            value: '56',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'Vocational or Professional Certification Completed (TAFE Diploma or Advanced Diploma)',
            value: '57',
            supportedCountries: [types_1.SUPPORTED_COUNTRY_ISO.AU]
        },
        {
            label: 'University Education Completed',
            value: '58',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Postgraduate Education Completed',
            value: '59',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Doctorate, Post-doctorate or equivalent Completed',
            value: '60',
            supportedCountries: [
                types_1.SUPPORTED_COUNTRY_ISO.AU,
                types_1.SUPPORTED_COUNTRY_ISO.NZ
            ]
        },
        {
            label: 'Prefer not to answer',
            value: '107',
            supportedCountries: types_1.ENG_COUNTRIES
        }
    ].filter(function (opt) { return opt.supportedCountries.includes(selectedCountry); });
    return __assign(__assign({}, (0, exports.getDefaultQuestion)(t, languages, translateKey, 'Education', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.EDUCATION = EDUCATION;
//# sourceMappingURL=common.js.map